import { ImageFilter } from "../models/Post";

const FILTER_CSS: Record<ImageFilter, string> = {
  grayscale: "grayscale(100%)",
  sepia: "sepia(100%)",
  invert: "invert(100%)",
};

/** Resolve the CSS `filter` value for an image. */
export function resolveImageFilterCss(
  filter: ImageFilter | undefined
): string | undefined {
  if (!filter) return undefined;
  return FILTER_CSS[filter];
}

export const IMAGE_FILTER_LABELS: Record<ImageFilter, string> = {
  grayscale: "B&W",
  sepia: "Sepia",
  invert: "Invert",
};

export const IMAGE_FILTER_OPTIONS: { value: ImageFilter | null; label: string }[] = [
  { value: null, label: "None" },
  { value: "grayscale", label: "B&W" },
  { value: "sepia", label: "Sepia" },
  { value: "invert", label: "Invert" },
];

/** CSS `filter` string for a filter value (alias of resolveImageFilterCss for legacy callers). */
export function imageFilterToCss(filter: ImageFilter | null | undefined): string | undefined {
  if (!filter) return undefined;
  return FILTER_CSS[filter];
}
